import { Button, Modal } from 'flowbite-react';
import { useState } from 'react';

export default function Modals() {
    const [openModal, setOpenModal] = useState(false);

    return (
        <>
            <Button  color='light' onClick={() => setOpenModal(true)} >Disclaimer</Button>
            <Modal show={openModal} onClose={() => setOpenModal(false)}>
                <Modal.Header>Alert</Modal.Header>
                <Modal.Body>
                    <div className="space-y-6">
                        <p className="text-base leading-relaxed ">
                            These set of questions are created on the basis of available syllabus and from the experience of previous year 
                            asked questions in viva exam of Web Technology.
                        </p>
                        <p className="text-base leading-relaxed ">
                            1. This is NOT a question bank!. Take these set of questions as basis of clearing basic concepts of 4 units under the 
                            Web Technology subject.
                        </p>
                        <p>
                            2. Focus more on Application based questions. Be thorough with your implementation concepts.
                        </p>
                        <p className='font-semibold'>
                            All The Very Best !
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button color='failure' onClick={() => {setOpenModal(false)}}>Continue</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
